import { render, staticRenderFns } from "./ChatBotPage.vue?vue&type=template&id=6884044c"
import script from "./ChatBotPage.vue?vue&type=script&lang=js"
export * from "./ChatBotPage.vue?vue&type=script&lang=js"
import style0 from "./ChatBotPage.vue?vue&type=style&index=0&id=6884044c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports